import type { ImportError, SkipReason } from '../services/importApi';

const HEADERS = ['Loại', 'Dòng', 'Cột', 'Lỗi', 'Giá trị', 'Số dòng'] as const;

/**
 * Excel bản tiếng Việt mở CSV theo code page hệ thống chứ không đoán UTF-8, nên
 * thiếu BOM thì mọi thông báo lỗi tiếng Việt hiện ra thành ký tự rác — đúng cái
 * mà người vận hành cần đọc nhất.
 */
const BOM = '﻿';

function escapeCell(value: unknown): string {
	if (value === null || value === undefined) return '';
	const text = String(value);
	// Dấu nháy kép, dấu phẩy và xuống dòng đều phải nằm trong cặp nháy; tên
	// trường THPT có dấu phẩy là chuyện thường.
	if (/[",\n\r]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
	return text;
}

/**
 * Gộp lỗi theo DÒNG và lý do bỏ qua theo NHÓM vào cùng một bảng phẳng, để mở
 * bằng Excel là lọc/sắp xếp được ngay. Hai loại nằm chung một file vì một lần
 * nhập hỏng thường có cả hai, và cột `Loại` đủ để tách chúng ra.
 */
export function buildImportErrorsCsv(
	errors: ImportError[] = [],
	skippedReasons: SkipReason[] = []
): string {
	const lines: string[] = [HEADERS.join(',')];

	for (const e of errors) {
		lines.push([
			'Lỗi dòng',
			e.row,
			e.column ?? '',
			e.message,
			e.value ?? '',
			''
		].map(escapeCell).join(','));
	}

	for (const s of skippedReasons) {
		lines.push(['Bỏ qua', '', '', s.reason, '', s.count].map(escapeCell).join(','));
	}

	return BOM + lines.join('\r\n') + '\r\n';
}

/** Tên file kèm mốc thời gian địa phương, để tải nhiều lần không ghi đè nhau. */
export function buildImportErrorsFilename(prefix: string, now: Date = new Date()): string {
	const p = (n: number) => String(n).padStart(2, '0');
	const stamp =
		`${now.getFullYear()}${p(now.getMonth() + 1)}${p(now.getDate())}` +
		`-${p(now.getHours())}${p(now.getMinutes())}${p(now.getSeconds())}`;
	return `${prefix}-${stamp}.csv`;
}

export function downloadImportErrorsCsv(
	errors: ImportError[] = [],
	skippedReasons: SkipReason[] = [],
	filenamePrefix = 'loi-nhap-du-lieu'
): void {
	const blob = new Blob([buildImportErrorsCsv(errors, skippedReasons)], {
		type: 'text/csv;charset=utf-8'
	});
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = buildImportErrorsFilename(filenamePrefix);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
}
